import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=1992ed24&scoped=true&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=1992ed24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992ed24",
  null
  
)

export default component.exports